import { FunctionComponent } from 'react'
import { Box, Typography } from '@black-bear-energy/rucksack'
import { ContractTypeAPIResponse } from '@black-bear-energy/black-bear-energy-common'
import { Field } from './Field'
import { SiteRFPDetailCard } from './SiteRFPDetailCard'
import { displayActualOrEstimatedDate } from '../helpers/displayActualOrEstimatedDate'

interface ContractsDetailCardProps {
  contractsName?: string | null
  contractStructure?: ContractTypeAPIResponse | null
  contractExecutionDate?: Date | null
  contractExecutionDateEstimate?: Date | null
}

const contractStructureLabels = {
  [ContractTypeAPIResponse.Lease]: 'Lease',
  [ContractTypeAPIResponse.PPA]: 'PPA',
  [ContractTypeAPIResponse.LeaseAndPPA]: 'Lease + PPA',
  [ContractTypeAPIResponse.EPC]: 'EPC',
  [ContractTypeAPIResponse.ESA]: 'ESA',
} as const satisfies Record<ContractTypeAPIResponse, string>

export const ContractsDetailCard: FunctionComponent<
  ContractsDetailCardProps
> = ({
  contractsName,
  contractStructure,
  contractExecutionDate,
  contractExecutionDateEstimate,
}) => {
  return (
    <SiteRFPDetailCard>
      <Typography variant="subtitle1">Contracts Details</Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Field label="Lead">{contractsName}</Field>
        <Field label="Structure">
          {contractStructure && contractStructureLabels[contractStructure]}
        </Field>
        <Field label="Contract Execution Date">
          {displayActualOrEstimatedDate(
            contractExecutionDate,
            contractExecutionDateEstimate
          )}
        </Field>
      </Box>
    </SiteRFPDetailCard>
  )
}
